import { render, staticRenderFns } from "./ValueInput.vue?vue&type=template&id=0da7b7a6&"
import script from "./ValueInput.vue?vue&type=script&lang=js&"
export * from "./ValueInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports